<template>
  <div class="blanks">
    <span v-for="(item, index) in issue.items" :key="index">
      {{ item.text }}
      <span v-if="item.length && item.content" class="blanks-opt-wrap">
        <input
          :type="item.content.inputType === 'number' ? 'text' : item.content.inputType"
          class="blanks-input"
          :style="{ width: item.length * 10 + 'px' }"
          v-model="item.value"
          @copy="onCopy"
          @paste="onPaste"
          @cut="onCut"
          :readonly="view||item.readonly"
          :placeholder="item.placeholder"
        />
        <span v-if="item.content.required" class="text-red">*</span>
      </span>
    </span>
    <template v-if="questionErrorText">
      <div class="text-danger mt-1">
        <span>{{questionErrorText}}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { hasValue } from 'dygc'
import disableCopyMixin from './disableCopyMixin'
export default {
  changeExpr: 'changeExpr',
  name: 'Blanks',
  mixins: [disableCopyMixin],
  computed: {
    items() {
      const items = this.issue.items
      return items.filter(i => i.content)
    },
    changeExpr() {
      return this.items.map(i => {
        return i.value
      }).join('-')
    },
    disableCopy() {
      return this.issue.disableCopy
    },
    questionErrorText(){
      return this.question.questionErrorList.map(i=>i.message).join('')
    }
  },
  methods: {}
}
</script>
